export default function Copyright(){
 return(
  <div className="copy">
   © 2026 KPLInfotech. All Rights Reserved
  </div>
 )
}
